import {
    QUIZ_ROUTE,
    QUIZ_INTRO_SETTINGS_ROUTE,
    QUIZ_REGISTRATION_SETTINGS_ROUTE,
    QUIZ_RESULT_SETTINGS_ROUTE,
    CHANGE_STATUS_ROUTE,
    QUIZ_DUPLICATE_ROUTE
} from './constants';
import http from '../../utils/httpService';

/**
 *
 * @param name
 * @param lang
 * @param quiz_type
 * @param person_type_count
 */
const requestQuizCreation = ( { name, lang, quiz_type, person_type_count } ) => {
    return http.request( QUIZ_ROUTE, 'POST', { name, lang_id: lang, type: quiz_type, person_type_count } );
};
/**
 *
 * @param typeQuiz
 * @param page
 * @param tenant
 * @param search
 * @param filter
 */
const requestAllQuizzes = ( typeQuiz, page, tenant, search, filter ) => {
    const route = QUIZ_ROUTE + `?type=${ typeQuiz }&page=${ page }&tenant=${ tenant }&search=${ search }&filter=${ filter }`;
    return http.request( route, 'GET' );
};
/**
 *
 * @param typeQuiz
 * @param page
 * @param tenant
 * @param search
 * @param filter
 */
const requestQuizFilter = ( typeQuiz, page, tenant, search, filter ) => {
    const route = QUIZ_ROUTE + `?type=${ typeQuiz }&page=${ page }&tenant=${ tenant }&search=${ search }&filter=${ filter }`;
    return http.request( route, 'GET' );
};
/**
 *
 * @param quizID
 * @param resolve
 * @param param
 */
const requestQuiz = ( quizID, resolve ) => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'GET', null, false, resolve );
};
/**
 *
 * @param quizPiece
 * @param quizID
 * @param resolve
 */
const requestQuizUpdate = ( quizPiece, quizID, resolve ) => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', quizPiece, false, resolve );
};
/**
 *
 * @param quizID
 */
const requestQuizDelete = quizID => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'DELETE' );
};
/**
 *
 * @param name
 * @param lang
 * @param quizID
 */
const requestQuizDuplication = ( name, lang, quizID ) => {
    return http.request( QUIZ_DUPLICATE_ROUTE + `/${ quizID }`, 'POST', { name, lang_id: lang } );
};

/**
 *
 * @param quizID
 * @param intro
 * @param resolve
 */
const requestUpdateQuizIntro = ( quizID, intro, resolve ) => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', intro, false, resolve );
};

const requestUpdateQuizIntroSettings = ( quizID, introSettings ) => {
    const route = QUIZ_INTRO_SETTINGS_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', introSettings );
};

/**
 *
 * @param quizID
 * @param registration
 */
const requestUpdateQuizRegistration = ( quizID, registration ) => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', registration );
};

/**
 *
 * @param quizID
 * @param result
 */
const requestUpdateQuizResult = ( quizID, result ) => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', result );
};
/**
 *
 * @param quizID
 * @param registrationSettings
 */
const requestUpdateQuizRegistrationSettings = ( quizID, registrationSettings ) => {
    const route = QUIZ_REGISTRATION_SETTINGS_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', registrationSettings );
};

/**
 *
 * @param quizID
 * @param result
 */
const requestUpdateQuizDragDrop = ( quizID, result ) => {
    const route = QUIZ_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', result );
};

/**
 *
 * @param quizID
 * @param resultSettings
 */
const requestUpdateQuizResultSettings = ( quizID, resultSettings ) => {
    const route = QUIZ_RESULT_SETTINGS_ROUTE + `/${ quizID }`;
    return http.request( route, 'PUT', resultSettings );
};

/**
 *
 * @param quizID
 */
const requestQuizChangeStatus = quizID => {
    const route = CHANGE_STATUS_ROUTE + `/${ quizID }`;
    return http.request( route, 'POST' );
};

/**
 *
 * @param tenant
 * @param from
 * @param to
 */
const requestGetTenantStatistic = ( tenant, from, to ) => {
    const data = {
        tenant: tenant,
        from: from,
        to: to
    };
    const route = QUIZ_ROUTE + '/tenant';
    return http.request( route, 'POST', data );
};

export {
    requestQuizCreation,
    requestAllQuizzes,
    requestQuiz,
    requestQuizUpdate,
    requestQuizDelete,
    requestUpdateQuizIntro,
    requestUpdateQuizIntroSettings,
    requestUpdateQuizRegistration,
    requestUpdateQuizRegistrationSettings,
    requestUpdateQuizResult,
    requestUpdateQuizDragDrop,
    requestQuizDuplication,
    requestUpdateQuizResultSettings,
    requestQuizFilter,
    requestQuizChangeStatus,
    requestGetTenantStatistic
};
